import { EstadoPadron } from '@shared/enums/estadoPadron';
import { Aborter } from '@azure/storage-blob';
import { TipoPadron, TipoRegimenARBA } from '@shared/enums/tiposPadron';

export class CargaPadron {

    private _progress: number = 0;
    private _tiempoUltimoBloque: Date;
    private _segundosRestantes: number = 0;
    private _aborter: Aborter;

    tipoPadron: TipoPadron;
    tipoRegimen: TipoRegimenARBA;
    tiempoRestante: number;
    fileName: string;
    cancelada: boolean;
    finalizada: boolean;
    error: string;
    _mensajeOk: string;

    constructor(filename: string, tipoPadron: TipoPadron, regimen?: TipoRegimenARBA) {
        this.fileName = filename;
        this.tipoPadron = tipoPadron;
        this.tipoRegimen = regimen;
    }

    setAborter(aborter: Aborter) {
        this._aborter = aborter;
    }

    get segundosRestantes(): number {
        return this._segundosRestantes;
    }

    get progress(): number {
        return this._progress;
    }

    set progress(prog) {
        if (this._tiempoUltimoBloque) {
            const proAnterior = this._progress;
            const diferenciaTiempo = (new Date()).valueOf() - this._tiempoUltimoBloque.valueOf(); //cuanto tardó en subir el ultimo bloque
            /**
             * (100 - prog) Porcentaje restante
             * (prog - proAnterior) Tamaño del bloque recien subido, en porcentaje
             * (100 - prog) / (prog - proAnterior) cuantos bloques faltan
             * (100 - prog) / (prog - proAnterior) * diferenciaTiempo Cuanto tiempo falta (en milisegundos)...
             * ...calculado en base a cuanto tardó en subir el último bloque
             */
            this._segundosRestantes = Math.round((this._segundosRestantes + ((100 - prog) / (prog - proAnterior) * diferenciaTiempo) / 1000) / 2);
        }
        this._tiempoUltimoBloque = new Date();
        this._progress = prog;
    }

    cancelarCarga() {
        this._aborter.abort();
        this.cancelada = true;
    }

    finalizar(mensaje: string) {
        this._mensajeOk = mensaje;
        this.finalizada = true;
        this.progress = 100;
    }

    get mensajeOk(): string {
        return this._mensajeOk;
    }

    get estado(): EstadoPadron {
        if (this.error)
            return EstadoPadron.Error;
        if (this.finalizada)
            return EstadoPadron.Finalizado;
        if (this.cancelada)
            return EstadoPadron.Cancelado;
        if (!this._aborter)
            return EstadoPadron.Preparando;
        if (this.progress < 100)
            return EstadoPadron.Subiendo;
        if (this.progress == 100)
            return EstadoPadron.Importando;
    }
}